import { GlobalAppState } from '@model/state';

export const getBookingDocuments = (state: GlobalAppState) => state.mmbDocuments.data;

export const getBookingDocumentsLoading = (state: GlobalAppState) => {
  return state.mmbDocuments.loading;
};
